
import { defineComponent, reactive, SetupContext, toRefs } from "vue";
import { useRouter } from "vue-router";
import { stateType, itemType } from "./farmingTask";
import { Dialog, Toast } from "vant";
import { igonreFarming } from "../../../api/farmer";
import { previewImage } from "@/utils/util";

const stateData = {
  item: {},
  router: {},
  context: {},
};
export default defineComponent({
  props: {
    datas: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
    types: {
      type: String,
      required: false,
      default: "edit",
    },
    sourceId: {
      type: String,
      default: "",
    },
  },
  setup(props: any, context: SetupContext) {
    const states = reactive<stateType>(stateData);
    states.router = useRouter();
    states.context = context;

    return {
      ...toRefs(states),
      ...useEvent(states, props),
    };
  },
});
const useEvent = (state: stateType, props: any) => {
  const preview = (url: string) => {
    previewImage(url);
  };
  const onShowDetail = (e: itemType) => {
    state.router.push({
      path: "/farmingDetail/" + e.id,
      query: {
        id: e.id,
        sourceId: props.sourceId,
      },
    });
  };
  const onRecord = (e: itemType) => {
    state.router.push({
      path: "/updateFarming",
      query: {
        item: JSON.stringify(e),
      },
    });
  };
  const onIgnore = (e: itemType) => {
    Dialog.confirm({ title: "标题", message: "是否忽略该任务？" }).then(() => {
      igonreFarming({
        id: e.id,
      }).then((res: any) => {
        if (res.data.code == 0) {
          Toast({
            message: "已忽略",
          });
          state.context.emit("update");
        }
      });
    });
  };
  return {
    onShowDetail,
    onIgnore,
    preview,
    onRecord,
  };
};
